import type { Modifier, Slot, StatId } from '@gra/content';

const STAT_LABELS: Record<StatId, string> = {
  maxHealth: 'zdrowia',
  moveSpeed: 'szybkości ruchu',
  pickupRadius: 'zasięgu zbierania',
  critChance: 'szansy na krytyk',
  armor: 'pancerza',
  regen: 'regeneracji/s',
  damage: 'obrażeń',
  cooldown: 'czasu odnowienia',
  projectileCount: 'pocisków',
  projectileSpeed: 'prędkości pocisków',
  pierce: 'przebicia',
  area: 'obszaru',
  range: 'zasięgu',
  goldGain: 'złota z wypraw',
  xpGain: 'doświadczenia',
  chestRate: 'częstości skrzyń',
  relicFind: 'szansy na przedmioty wyprawy',
  critDamage: 'obrażeń krytycznych',
  executeBelow: 'dobijania',
  lifeOnKill: 'zdrowia za zabójstwo',
  dodgeChance: 'szansy na unik',
  barrier: 'bariery (z maks. zdrowia)',
  thorns: 'obrażeń od kolców/s',
  luck: 'szczęścia',
};

/** Statystyki „add” podawane w procentach (0,05 = 5%). */
const PERCENT_ADD = new Set<StatId>(['critChance', 'critDamage', 'dodgeChance', 'barrier', 'luck']);

const TAG_LABELS: Record<string, string> = {
  projectile: 'pociski',
  area: 'obszarowe',
  fire: 'ogień',
  arcane: 'arkana',
  frost: 'mróz',
  physical: 'fizyczne',
  melee: 'wręcz',
  lightning: 'błyskawice',
};

export const SLOT_LABELS: Record<Slot, string> = {
  weapon: 'Broń',
  offhand: 'Druga ręka',
  head: 'Głowa',
  back: 'Plecy',
  chest: 'Tułów',
  legs: 'Nogi',
  hands: 'Dłonie',
  feet: 'Stopy',
};

const num = (v: number) => (Math.round(v * 10) / 10).toString().replace('.', ',');

/** Czy modyfikator pomaga graczowi (krótszy czas odnowienia to zysk, mimo ujemnej wartości). */
export function isGoodModifier(m: Modifier): boolean {
  return m.stat === 'cooldown' ? m.value <= 0 : m.value >= 0;
}

export function describeModifier(m: Modifier): string {
  const sign = m.value >= 0 ? '+' : '−';
  const v = Math.abs(m.value);
  let text: string;
  if (m.op === 'mul') text = `${sign}${Math.round(v * 100)}% ${STAT_LABELS[m.stat]}`;
  else if (m.stat === 'executeBelow') text = `dobija wrogów poniżej ${num(v * 100)}% zdrowia`;
  else if (PERCENT_ADD.has(m.stat)) text = `${sign}${num(v * 100)}% ${STAT_LABELS[m.stat]}`;
  else text = `${sign}${num(v)} ${STAT_LABELS[m.stat]}`;
  if (m.tags?.length) text += ` (${m.tags.map((t) => TAG_LABELS[t] ?? t).join(', ')})`;
  return text;
}
